/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";
import paypalLogo from "../paypal-logo.png";
import guaranteeLogo from "../60-day-guarantee.png";

const CardsComponent = () => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        align: "start",
        breakpoints: {
            992: { dragFree: true },
        },
    });

    const [scrollProgress, setScrollProgress] = useState(0);

    const onScroll = useCallback((emblaApi) => {
        const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress()));
        setScrollProgress(progress * 100);
    }, []);

    useEffect(() => {
        if (!emblaApi) return;

        onScroll(emblaApi);

        emblaApi
            .on("reInit", onScroll)
            .on("scroll", onScroll)
            .on("slideFocus", onScroll);
    }, [emblaApi, onScroll]);

    return (
        <div ref={emblaRef} className="overflow-hidden">
            <div className="flex gap-[15px] md:gap-[30px]">
                <div className="flex flex-[0_0_240px] flex-col gap-y-[30px] rounded-[10px] bg-brand-light-grey p-[15px] md:flex-1">
                    <div className="flex flex-col items-start gap-y-[10px]">
                        <img
                            src={paypalLogo}
                            alt="PayPal"
                            className="h-[16px] w-auto"
                        />

                        <div className="flex flex-col gap-[5px]">
                            <p className="!mb-0 font-extrabold">
                                Split payments with PayPal
                            </p>
                            <p className="!mb-0">0% for 3 months</p>
                        </div>
                    </div>
                </div>

                <div className="flex flex-[0_0_240px] flex-col gap-y-[30px] rounded-[10px] bg-brand-light-grey p-[15px] md:flex-1">
                    <div className="flex flex-col items-start gap-y-[10px]">
                        <svg
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.5 8C11.5 8.71875 11.4375 9.375 11.375 10H5.59375C5.53125 9.375 5.5 8.71875 5.5 8C5.5 7.3125 5.53125 6.65625 5.59375 6H11.375C11.4375 6.65625 11.5 7.3125 11.5 8ZM12.375 6H16.2188C16.4062 6.65625 16.5 7.3125 16.5 8C16.5 8.71875 16.4062 9.375 16.2188 10H12.375C12.4375 9.375 12.5 8.6875 12.5 8C12.5 7.3125 12.4375 6.65625 12.375 6ZM15.9062 5H12.25C11.9375 3.03125 11.3125 1.34375 10.5312 0.28125C12.9688 0.9375 14.9688 2.6875 15.9062 5ZM11.25 5H5.71875C5.90625 3.875 6.21875 2.875 6.5625 2.0625C6.90625 1.3125 7.25 0.78125 7.625 0.4375C7.96875 0.125 8.25 0 8.5 0C8.71875 0 9 0.125 9.34375 0.4375C9.71875 0.78125 10.0625 1.3125 10.4062 2.0625C10.75 2.875 11.0625 3.875 11.25 5ZM4.71875 5H1.0625C2 2.6875 4 0.9375 6.4375 0.28125C5.65625 1.34375 5.03125 3.03125 4.71875 5ZM0.75 6H4.59375C4.53125 6.65625 4.5 7.3125 4.5 8C4.5 8.6875 4.53125 9.375 4.59375 10H0.75C0.5625 9.375 0.5 8.71875 0.5 8C0.5 7.3125 0.5625 6.65625 0.75 6ZM6.5625 13.9688C6.21875 13.1562 5.90625 12.1562 5.71875 11H11.25C11.0625 12.1562 10.75 13.1562 10.4062 13.9688C10.0625 14.7188 9.71875 15.25 9.34375 15.5938C9 15.9062 8.71875 16 8.5 16C8.25 16 7.96875 15.9062 7.625 15.5938C7.25 15.25 6.90625 14.7188 6.5625 13.9688ZM4.71875 11C5.03125 13 5.65625 14.6875 6.4375 15.75C4 15.0938 2 13.3438 1.0625 11H4.71875ZM15.9062 11C14.9688 13.3438 12.9688 15.0938 10.5312 15.75C11.3438 14.6875 11.9375 13 12.25 11H15.9062Z"
                                fill="#222222"
                            />
                        </svg>

                        <div className="flex flex-col gap-[5px]">
                            <p className="!mb-0 font-extrabold">
                                The world leader
                            </p>
                            <p className="!mb-0">
                                We&apos;re the world&apos;s largest manufacturer
                                of food waste disposers.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="flex flex-[0_0_240px] flex-col gap-y-[30px] rounded-[10px] bg-brand-light-grey p-[15px] md:flex-1">
                    <div className="flex flex-col items-start gap-y-[10px]">
                        <img
                            src={guaranteeLogo}
                            alt="60 Day Money Back Guarantee"
                            className="h-[40px] w-auto"
                        />

                        <div className="flex flex-col gap-[5px]">
                            <p className="!mb-0 font-extrabold">
                                60 Day Money Back Guarantee
                            </p>
                            <p className="!mb-0">
                                If you&apos;re not completely satisfied within
                                60 days*
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardsComponent;
